import React from 'react';
import './Hamburger.css';

interface HamburgerProps {
  isOpen: boolean;
  onClick: () => void;
}

const Hamburger: React.FC<HamburgerProps> = ({ isOpen, onClick }) => {
  return (
    <button
      className={`hamburger ${isOpen ? 'active' : ''}`}
      onClick={onClick}
      aria-label="Menu"
      aria-expanded={isOpen}
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
  );
};

export default Hamburger;



